import { APIResponse } from '../../../../@types/api-response';
import { emittenEndpoint } from '../constants/apiEndpoint';
import { EmittenInfoResponse } from '../types/api/emittenInfo';
import { exodusApiInstance } from './instance/exodus';

export const getEmittenInfo = async (
  symbol: string,
): Promise<APIResponse<EmittenInfoResponse>> =>
  exodusApiInstance.disabledErrorAlert.get(emittenEndpoint.emittenInfo(symbol));
